<template>
<!-- center col START -->
    <div class="centerCol boxgam"><!-- class boxgam -->

      <!-- row-th6-top start -->
      <div class="row-th6-top">
        <div class="th" @click="$router.push({name: 'MainTab'})">{{$t('main')}}</div><!-- +/- class lightgreen -->
        <div class="th" @click="$router.push({name: 'OverUnder'})">{{$t('ov/un')}}</div><!-- +/- class lightgreen -->
        <div class="th" @click="$router.push({name: 'HomeOVUN'})">{{$t('homeovun')}}</div><!-- +/- class lightgreen -->
        <div class="th" @click="$router.push({name: 'AwayOVUN'})">{{$t('awayovun')}}</div><!-- +/- class lightgreen -->
        <div class="th" @click="$router.push({name: '1X2OVUN1'})">{{$t('1x2ovun')}}</div><!-- +/- class lightgreen -->
        <div class="th" @click="$router.push({name: '1X2OVUN2'})">{{$t('1x2ovun2')}}</div><!-- +/- class lightgreen -->
      </div>
      <!-- row-th6-top stop -->

      <!-- boxgamTop start -->
      <div class="boxgamTop">
        <div class="icon"><img :src="getimg(Match.HomeTeam)" alt=""></div>
        <div class="name">{{getteams(Match.HomeTeam)}}</div>
        <div class="vs">vs</div>
        <div class="name">{{getteams(Match.AwayTeam)}}</div>
        <div class="icon"><img :src="getimg(Match.AwayTeam)" alt=""></div>
      </div>
      <!-- boxgamTop stop -->

      <!-- Total goals start -->
      <div class="totalGoals">{{$t('tg')}}</div>
      <div class="row-tb">

        <div class="td-tb">
          <p>1</p>
          <p :class="classchange(Match, 'Goals(1)')" @click="addbet('Goals(1)', Match.Odds['Goals(1)'], Match)">{{Match.Odds['Goals(1)']}}</p>
        </div>

        <div class="td-tb">
          <p>2</p>
          <p :class="classchange(Match, 'Goals(2)')" @click="addbet('Goals(2)', Match.Odds['Goals(2)'], Match)">{{Match.Odds['Goals(2)']}}</p>
        </div>

        <div class="td-tb">
          <p>3</p>
          <p :class="classchange(Match, 'Goals(3)')" @click="addbet('Goals(3)', Match.Odds['Goals(3)'], Match)">{{Match.Odds['Goals(3)']}}</p>
        </div>

        <div class="td-tb">
          <p>4</p>
          <p :class="classchange(Match, 'Goals(4)')" @click="addbet('Goals(4)', Match.Odds['Goals(4)'], Match)">{{Match.Odds['Goals(4)']}}</p>
        </div>

        <div class="td-tb">
          <p>5</p>
          <p :class="classchange(Match, 'Goals(5)')" @click="addbet('Goals(5)', Match.Odds['Goals(5)'], Match)">{{Match.Odds['Goals(5)']}}</p>
        </div>

        <div class="td-tb">
          <p>6</p>
          <p :class="classchange(Match, 'Goals(6)')" @click="addbet('Goals(6)', Match.Odds['Goals(6)'], Match)">{{Match.Odds['Goals(6)']}}</p>
        </div>

      </div>
      <!-- Total goals stop -->

      <!-- Home Draw Away start -->
      <div class="hda">

        <!-- hda-1 start -->
        <div class="hda-1">
          <div class="title">{{$t('home')}}</div>
          <div class="hda-table">

            <!-- hda-row start -->
            <div class="hda-row">

              <div class="td-tb">
                <p>1-0</p>
                <p :class="classchange(Match, '1-0')" @click="addbet('1-0', Match.Odds['1-0'], Match)">{{Match.Odds['1-0']}}</p>
              </div>
      
              <div class="td-tb">
                <p>2-1</p>
                <p :class="classchange(Match, '2-1')" @click="addbet('2-1', Match.Odds['2-1'], Match)">{{Match.Odds['2-1']}}</p>
              </div>
      
              <div class="td-tb">
                <p>3-2</p>
                <p :class="classchange(Match, '3-2')" @click="addbet('3-2', Match.Odds['3-2'], Match)">{{Match.Odds['3-2']}}</p>
              </div>

            </div>
            <!-- hda-row stop -->

            <!-- hda-row start -->
            <div class="hda-row">

              <div class="td-tb">
                <p>2-0</p>
                <p :class="classchange(Match, '2-0')" @click="addbet('2-0', Match.Odds['2-0'], Match)">{{Match.Odds['2-0']}}</p>
              </div>
      
              <div class="td-tb">
                <p>3-1</p>
                <p :class="classchange(Match, '3-1')" @click="addbet('3-1', Match.Odds['3-1'], Match)">{{Match.Odds['3-1']}}</p>
              </div>
      
              <div class="td-tb">
                <p>4-2</p>
                <p :class="classchange(Match, '4-2')" @click="addbet('4-2', Match.Odds['4-2'], Match)">{{Match.Odds['4-2']}}</p>
              </div>

            </div>
            <!-- hda-row stop -->

            <!-- hda-row start -->
            <div class="hda-row">

              <div class="td-tb">
                <p>3-0</p>
                <p :class="classchange(Match, '3-0')" @click="addbet('3-0', Match.Odds['3-0'], Match)">{{Match.Odds['3-0']}}</p>
              </div>
      
              <div class="td-tb">
                <p>4-1</p>
                <p :class="classchange(Match, '4-1')" @click="addbet('4-1', Match.Odds['4-1'], Match)">{{Match.Odds['4-1']}}</p>
              </div>

              <div class="td-tb">
                
              </div>

            </div>
            <!-- hda-row stop -->

            <!-- hda-row start -->
            <div class="hda-row">

              <div class="td-tb">
                <p>4-0</p>
                <p :class="classchange(Match, '4-0')" @click="addbet('4-0', Match.Odds['4-0'], Match)">{{Match.Odds['4-0']}}</p>
              </div>

              <div class="td-tb">
                <p>5-1</p>
                <p :class="classchange(Match, '5-1')" @click="addbet('5-1', Match.Odds['5-1'], Match)">{{Match.Odds['5-1']}}</p>
              </div>

              <div class="td-tb">
                
              </div>

            </div>
            <!-- hda-row stop -->

            <!-- hda-row start -->
            <div class="hda-row">

              <div class="td-tb">
                <p>5-0</p>
                <p :class="classchange(Match, '5-0')" @click="addbet('5-0', Match.Odds['5-0'], Match)">{{Match.Odds['5-0']}}</p>
              </div>

            </div>
            <!-- hda-row stop -->

            <!-- hda-row start -->
            <div class="hda-row">

              <div class="td-tb">
                <p>6-0</p>
                <p :class="classchange(Match, '6-0')" @click="addbet('6-0', Match.Odds['6-0'], Match)">{{Match.Odds['6-0']}}</p>
              </div>

            </div>
            <!-- hda-row stop -->

          </div>
        </div>
        <!-- hda-1 stop -->

        <!-- hda-2 start -->
        <div class="hda-2">
          <div class="title">{{$t('draw')}}</div>
          <div class="hda-table">

            <!-- hda-row start -->
            <div class="hda-row">
              
              <div class="td-tb">
                <p>0-0</p>
                <p :class="classchange(Match, '0-0')" @click="addbet('0-0', Match.Odds['0-0'], Match)">{{Match.Odds['0-0']}}</p>
              </div>

            </div>
            <!-- hda-row stop -->

            <!-- hda-row start -->
            <div class="hda-row">
              
              <div class="td-tb">
                <p>1-1</p>
                <p :class="classchange(Match, '1-1')" @click="addbet('1-1', Match.Odds['1-1'], Match)">{{Match.Odds['1-1']}}</p>
              </div>

            </div>
            <!-- hda-row stop -->

            <!-- hda-row start -->
            <div class="hda-row">
              
              <div class="td-tb">
                <p>2-2</p>
                <p :class="classchange(Match, '2-2')" @click="addbet('2-2', Match.Odds['2-2'], Match)">{{Match.Odds['2-2']}}</p>
              </div>

            </div>
            <!-- hda-row stop -->

            <!-- hda-row start -->
            <div class="hda-row">
              
              <div class="td-tb">
                <p>3-3</p>
                <p :class="classchange(Match, '3-3')" @click="addbet('3-3', Match.Odds['3-3'], Match)">{{Match.Odds['3-3']}}</p>
              </div>

            </div>
            <!-- hda-row stop -->

          </div>
        </div>
        <!-- hda-2 stop -->

        <!-- hda-3 start -->
        <div class="hda-3">
          <div class="title">{{$t('away')}}</div>
          <div class="hda-table">

            <!-- hda-row start -->
            <div class="hda-row">
              
              <div class="td-tb">
                <p>2-3</p>
                <p :class="classchange(Match, '2-3')" @click="addbet('2-3', Match.Odds['2-3'], Match)">{{Match.Odds['2-3']}}</p>
              </div>
              
              <div class="td-tb">
                <p>1-2</p>
                <p :class="classchange(Match, '1-2')" @click="addbet('1-2', Match.Odds['1-2'], Match)">{{Match.Odds['1-2']}}</p>
              </div>
              
              <div class="td-tb">
                <p>0-1</p>
                <p :class="classchange(Match, '0-1')" @click="addbet('0-1', Match.Odds['0-1'], Match)">{{Match.Odds['0-1']}}</p>
              </div>

            </div>
            <!-- hda-row stop -->

            <!-- hda-row start -->
            <div class="hda-row">
              
              <div class="td-tb">
                <p>2-4</p>
                <p :class="classchange(Match, '2-4')" @click="addbet('2-4', Match.Odds['2-4'], Match)">{{Match.Odds['2-4']}}</p>
              </div>
              
              <div class="td-tb">
                <p>1-3</p>
                <p :class="classchange(Match, '1-3')" @click="addbet('1-3', Match.Odds['1-3'], Match)">{{Match.Odds['1-3']}}</p>
              </div>
              
              <div class="td-tb">
                <p>0-2</p>
                <p :class="classchange(Match, '0-2')" @click="addbet('0-2', Match.Odds['0-2'], Match)">{{Match.Odds['0-2']}}</p>
              </div>

            </div>
            <!-- hda-row stop -->

            <!-- hda-row start -->
            <div class="hda-row">

              <div class="td-tb">
                
              </div>
              
              <div class="td-tb">
                <p>1-4</p>
                <p :class="classchange(Match, '1-4')" @click="addbet('1-4', Match.Odds['1-4'], Match)">{{Match.Odds['1-4']}}</p>
              </div>
              
              <div class="td-tb">
                <p>0-3</p>
                <p :class="classchange(Match, '0-3')" @click="addbet('0-3', Match.Odds['0-3'], Match)">{{Match.Odds['0-3']}}</p>
              </div>

            </div>
            <!-- hda-row stop -->

            <!-- hda-row start -->
            <div class="hda-row">

              <div class="td-tb">

              </div>

              <div class="td-tb">
                <p>1-5</p>
                <p :class="classchange(Match, '1-5')" @click="addbet('1-5', Match.Odds['1-5'], Match)">{{Match.Odds['1-5']}}</p>
              </div>
              
              <div class="td-tb">
                <p>0-4</p>
                <p :class="classchange(Match, '0-4')" @click="addbet('0-4', Match.Odds['0-4'], Match)">{{Match.Odds['0-4']}}</p>
              </div>

            </div>
            <!-- hda-row stop -->

            <!-- hda-row start -->
            <div class="hda-row">

              <div class="td-tb">

              </div>

              <div class="td-tb">

              </div>
              
              <div class="td-tb">
                <p>0-5</p>
                <p :class="classchange(Match, '0-5')" @click="addbet('0-5', Match.Odds['0-5'], Match)">{{Match.Odds['0-5']}}</p>
              </div>

            </div>
            <!-- hda-row stop -->

            <!-- hda-row start -->
            <div class="hda-row">

              <div class="td-tb">

              </div>

              <div class="td-tb">

              </div>
              
              <div class="td-tb">
                <p>0-6</p>
                <p :class="classchange(Match, '0-6')" @click="addbet('0-6', Match.Odds['0-6'], Match)">{{Match.Odds['0-6']}}</p>
              </div>

            </div>
            <!-- hda-row stop -->

          </div>
        </div>
        <!-- hda-3 stop -->

      </div>
      <!-- Home Draw Away stop -->

    </div>
    <!-- center col STOP -->
</template>

<script>
import Vue from 'vue'
import Cookies from 'js-cookie'

export default {
  name: 'Football',
  created() { 
    this.Match = this.$route.params;
  },
  methods: {
    addbet(name, price, game){
      let bet = {
        GameID: this.$store.state.game.GameID,
        MatchID: game.MatchID,
        HomeTeam: game.HomeTeam,
        AwayTeam: game.AwayTeam,
        Bet: name,
        Price: price,     
        Amount: 0,
      }
      if(this.$store.state.Bets.some(elem => elem.MatchID === bet.MatchID && elem.Bet === bet.Bet)){
        return this.$store.state.Bets.splice(bet, 1);
      }else if(this.$store.state.Bets.some(elem => elem.MatchID === bet.MatchID)){
        return
      }else{
        return this.$store.dispatch('addbet', {bet: bet});
      }
    },
    classchange(match, bet){
      if(this.$store.state.Bets == null) return
      if(this.$store.state.Bets.find( function(item){
        if(item.MatchID == match.MatchID) {
          if(item.Bet == bet) return true }
      })) return 'bgBrownburgundy'
    },
    getteams(team){
      let result = this.$store.state.teams.filter(item => item.id == team);
      return result[0].Name
    },
    getimg(name){
      let result = this.$store.state.teams.filter(item => item.id == name);
      if(result[0].Icon != ""){
        return "https://champs-admin.info/gallery/" + result[0].Icon
      }
    }
  },
  data: ()=>{
    return {
      Match: null,
    }
  }
  
};
</script>